<style scoped lang="scss">
@import '~variables';

.typeahead {
    position: relative;

    .input {
        position: relative;

        .far {
            position: absolute;
            right: .25em;
            top: calc(50% - .5em);
            font-size: 1.3rem;
            color: $gray-500;
        }
    }

    .dropdown {
        position: absolute;
        left: 0;
        right: 0;
        background: white;
        border: 1px solid silver;
        box-shadow: 1px 2px 3px rgba(0,0,0, .1);
        padding: 1rem;
        margin-top: .25rem;
        border-radius: 4px;

        .results {
            display: flex;
            flex-direction: column;

            .item {
                display: block;
                text-align: left;
            }
        }
    }
}

</style>

<template>
    <div class="form-group typeahead" v-if="search && search.filters[filterIndex]">
        <div class="input">
            <input type="search" class="form-control" @blur="blur" v-model="search.filters[filterIndex].value" @input="debounceInput" v-bind:placeholder="trans.get('datatable.search')">
            <span class="far fa-times-circle" @click="reset()"></span>
        </div>
        <div class="dropdown" v-if="show">
            <div v-if="search.isLoading">
                {{ trans.get('datatable.loading') }}
            </div>
            <div v-if="!search.isLoading && results.length === 0">
                {{ trans.get('datatable.no-results') }}
            </div>
            <div class="results" v-if="!search.isLoading">
                <button type="button" class="btn btn-link item" @click="select(item)" v-for="item in results">
                    <slot :item="item"></slot>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    let debounce = require('debounce');

    export default {

        props: {
            search: undefined,
            filterIndex: {
                type: Number,
                default: 0
            },
            fields: {
                type: Array,
                default: [
                    {
                        field: 'id',
                        type: 'where'
                    }
                ]
            },
        },

        data() {
            return {
                show: false,
                results: [],
            }
        },

        methods: {

            blur() {
                setTimeout(() => {
                    this.reset();
                }, 200);
            },

            reset() {
                this.show = false;
                this.search.resetFilter(this.filterIndex);
            },

            select(item) {
                this.$emit('selected', item);
                this.blur();
            },

            debounceInput: debounce(function (e) {
                this.search.page = 1;
                this.search.addFilterFields(this.fields, this.filterIndex);

                this.show = true;
                this.search.search()
                    .then(data => {
                        this.results = data.data;
                    })
                    .catch(err => {
                        console.log(err);
                    });

            }, 500),
        }
    }
</script>
